"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageUsageDashboardWidget = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@veeam/core");
const components_1 = require("../../../../components");
const core_2 = require("../../../../core");
const helpers_1 = require("../../../../helpers");
const Snapshot32_svg_1 = __importDefault(require("../../../../assets/icons/dashboard/Snapshot32.svg"));
const Replica_snapshots32_svg_1 = __importDefault(require("../../../../assets/icons/dashboard/Replica_snapshots32.svg"));
const Backup32_svg_1 = __importDefault(require("../../../../assets/icons/dashboard/Backup32.svg"));
const Archive32_svg_1 = __importDefault(require("../../../../assets/icons/dashboard/Archive32.svg"));
require("../../../../components/DashboardWidgets/StorageWidget");
const StorageUsageInteractor_1 = require("./StorageUsageInteractor");
require("./types");
const helpers_2 = require("./helpers");
const StorageUsageDashboardWidget = ({ loadableModel, }) => {
    const { t } = core_2.useFeatureContext();
    const { isAws, isAzure, isGcp } = core_2.useProductContext();
    core_1.useInteractor(() => {
        return new StorageUsageInteractor_1.StorageUsageInteractor(loadableModel);
    });
    const { value, meta: { loading: isLoading }, } = core_1.useModel(loadableModel);
    const widgetData = [
        {
            icon: Snapshot32_svg_1.default,
            title: t('dashboard|storageUsage|jobType|snapshots'),
            description: value.snapshotsCount.toString(),
        },
        {
            icon: Backup32_svg_1.default,
            title: t('dashboard|storageUsage|jobType|backups'),
            description: helpers_2.getSizeText(value.backupsUsage),
        },
        {
            icon: Archive32_svg_1.default,
            title: t('dashboard|storageUsage|jobType|archives'),
            description: helpers_2.getSizeText(value.archivesUsage),
        },
    ];
    if (isAws() && 'replicasCount' in value) {
        widgetData.splice(2, 0, {
            icon: Replica_snapshots32_svg_1.default,
            title: t('dashboard|storageUsage|jobType|replicaSnapshots'),
            description: value.replicasCount.toString(),
        });
    }
    if (isGcp() && 'snapshotsUsage' in value) {
        widgetData.splice(0, 1, {
            icon: Snapshot32_svg_1.default,
            title: t('dashboard|storageUsage|jobType|snapshots'),
            description: helpers_2.getSizeText(value.snapshotsUsage),
            secondDescription: t('dashboard|storageUsage|jobType|snapshotsNumber', {
                count: value.snapshotsCount.toString(),
            }),
        });
    }
    let chartsData = [];
    if (isAws() && 's3usage' in value) {
        chartsData = [
            {
                text: t('dashboard|storageUsage|storageType|s3'),
                value: Number(helpers_1.formatBytes(value.s3usage, 0, false)),
                suffix: helpers_1.getBytesSize(value.s3usage),
            },
            {
                text: t('dashboard|storageUsage|storageType|glacier'),
                value: Number(helpers_1.formatBytes(value.glacierUsage, 0, false)),
                suffix: helpers_1.getBytesSize(value.glacierUsage),
            },
            {
                text: t('dashboard|storageUsage|storageType|deepGlacier'),
                value: Number(helpers_1.formatBytes(value.deepGlacierUsage, 0, false)),
                suffix: helpers_1.getBytesSize(value.deepGlacierUsage),
            },
        ];
    }
    if (isAzure() && 'hotUsage' in value) {
        chartsData = [
            {
                text: t('dashboard|storageUsage|storageType|hot'),
                value: Number(helpers_1.formatBytes(value.hotUsage, 0, false)),
                suffix: helpers_1.getBytesSize(value.hotUsage),
            },
            {
                text: t('dashboard|storageUsage|storageType|cool'),
                value: Number(helpers_1.formatBytes(value.coolUsage, 0, false)),
                suffix: helpers_1.getBytesSize(value.coolUsage),
            },
            {
                text: t('dashboard|storageUsage|storageType|archive'),
                value: Number(helpers_1.formatBytes(value.archiveUsage, 0, false)),
                suffix: helpers_1.getBytesSize(value.archiveUsage),
            },
        ];
    }
    if (isGcp() && 'standardUsage' in value) {
        chartsData = [
            {
                text: t('dashboard|storageUsage|storageType|standard'),
                value: Number(helpers_1.formatBytes(value.standardUsage, 0, false)),
                suffix: helpers_1.getBytesSize(value.standardUsage),
            },
            {
                text: t('dashboard|storageUsage|storageType|archive'),
                value: Number(helpers_1.formatBytes(value.archiveUsage, 0, false)),
                suffix: helpers_1.getBytesSize(value.archiveUsage),
            },
        ];
    }
    const totalUsageBytes = StorageUsageInteractor_1.StorageUsageInteractor.countTotalUsageBytes(value);
    return (react_1.default.createElement(components_1.DashboardPlate, { title: t('dashboard|storageUsage|header'), content: react_1.default.createElement(components_1.StorageWidget, { isLoading: isLoading, data: widgetData, chartsData: chartsData, total: Number(helpers_1.formatBytes(totalUsageBytes, 0, false)), totalLabel: t('dashboard|storageUsage|storageType|total'), totalSuffix: helpers_1.getBytesSize(totalUsageBytes) }) }));
};
exports.StorageUsageDashboardWidget = StorageUsageDashboardWidget;
//# sourceMappingURL=StorageUsageDashboardWidget.js.map